import { Form } from 'react-bootstrap';

export const IssueGroupingToggle = ({ groupIssues, onToggleGrouping }) => {
  return (
    <div className="d-flex align-items-center gap-3">
      <label htmlFor="groupIssuesToggle" className="mb-0">
        <strong>GROUP SIMILAR ISSUES</strong>
      </label>
      <div className="d-flex align-items-center gap-2">
        <Form.Check 
          type="switch"
          id="groupIssuesToggle"
          checked={groupIssues}
          onChange={onToggleGrouping}
        />
        <span 
          style={{ 
            minWidth: '60px',
            textAlign: 'left',
            fontWeight: 'bold'
          }}
          aria-live="polite"
        >
          {groupIssues ? "Grouped" : "Individual"}
        </span>
      </div>
    </div>
  );
};